import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Collection } from 'src/app/interfaces/collection';
import { SharedService } from 'src/app/services/shared.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-edit-collection-modal',
  templateUrl: './edit-collection-modal.component.html',
  styleUrls: ['./edit-collection-modal.component.scss'],
})
export class EditCollectionModalComponent implements OnInit {
  visible = false;
  @Input() collection: Collection = {
    uid: this.firestore.createId(),
    name: '',
    owner: this.userService.user?.uid,
    createdAt: new Date(),
    modifiedAt: new Date(),
    members: [this.userService.user?.uid],
  };
  @Output() close = new EventEmitter<void>();
  @Output() save = new EventEmitter<Collection>();

  constructor(
    private firestore: AngularFirestore,
    private userService: UserService,
    public sharedService: SharedService
  ) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.visible = true;
    }, 0);
  }
}
